import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { LoginForm } from 'components/Auth/LoginForm';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useActions } from 'store';
import { login } from 'store/session/actions';
import { getSession } from 'store/session/selectors';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { useDidMount } from 'hooks/useDidMount';

export const LoginPage = () => {
    const { isLoading, user } = useSelector(getSession);

    const actions = useActions({ login });
    const navigate = useNavigate();

    const loginHandler = useCallback((email: string, password: string) => {
        actions.login({ email, password, onSuccess: () => navigate(-1) });
    }, []);

    useDidMount(() => {
        if (user) {
            navigate(PATH.ROOT);
        }
    });

    return (
        <Box
            p={2}
            display="flex"
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
            px={2.5}
            py={2}
        >
            <Card title="Login">
                <LoginForm onLogin={loginHandler} />
            </Card>
            {isLoading.user && <BackdropLoader />}
        </Box>
    );
};
